import React from "react";
import Navbar from "../features/Navbar/Navbar";
import AdminProductDetails from "../features/admin/Component/AdminProductDetails";

export default function AdminProductDetailPage() {
  return (
    <>
      <Navbar></Navbar>
      <AdminProductDetails></AdminProductDetails>
    </>
  );
}
